var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('el-image',{attrs:{"fit":"contain","src":_vm.src},on:{"error":function($event){return _vm.actionRetry()}}},[_c('div',{attrs:{"slot":"error"},slot:"error"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }